import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export type CodigoPromocional = {
  id?: number;
  codigo: string;
  descripcion?: string | null;
  tipo_descuento: 'PORCENTAJE' | 'MONTO';
  valor: number;
  vigencia_inicio?: string | null;
  vigencia_fin?: string | null;
  limite_usos: number;
  usos?: number;
  activo?: boolean;
  acumulable?: boolean;
  evento_id?: number | null;
};

export async function obtenerCodigosPromocionales() {
  const response = await axios.get(`${API_URL}codigoPromocional`);
  return response.data?.doc?.data?.rows || [];
}

export async function crearCodigoPromocionalService(values: CodigoPromocional) {
  const response = await axios.post(`${API_URL}codigoPromocional`, values);
  return response.data?.doc?.data;
}

export async function actualizarCodigoPromocionalService(
  id: number,
  values: Partial<CodigoPromocional>
) {
  const response = await axios.put(`${API_URL}codigoPromocional/${id}`, values);
  return response.data?.doc?.data;
}
